const DOMAIN = window.location.origin
export const  API_URL = DOMAIN+'/rest/s1/returns'
export const PRODUCTION_PATH = '/returns/'

export const ORIGIN_ID = 'ReturnsPortal';

// Page URL
export const  ORDERSEARCH_PAGE = '/ordersearch'
export const  ORDERDETAILS_PAGE = '/orderdetails' 
export const  CLERKLOGIN_PAGE = '/login'
export const  ORDERLISTING_PAGE = '/orderlisting'
export const  RETURNINSTRUCTIONS_PAGE = '/returninstructions'

// API URL
export const  GET_STORE_DESIGN_URL = '/setting'
export const  GET_ORDER_DATA_URL = '/orderDetail'
export const  GET_CONTACT_MECH_DATA_URL = '/contanctMechInfo'
export const  GET_ITEM_EXCHANGE_DATA_URL = '/itemExchangeInfo'
export const  GET_MOQUI_SESSION= DOMAIN+'/rest/moquiSessionToken'
export const  CREATE_RMA_URL   = '/RMA'
export const  GET_RMA_SHIPPING_LABEL_AS_IMAGE_URL   = '/RMAInfo/shippingLabelAsImage' 
export const  SHIPPING_LABEL_IMG_FORMAT = '.png';
export const  GET_RMA_DATA_URL   = '/RMAInfo' 
export const  STORE_CLERK_LOGIN   = '/login'
export const  STORE_CLERK_LOGOUT_URL = '/logout'
export const  GET_ORDER_LISTING_URL = '/orderListing'
export const  OVERRIDE_ELIGIBLE  = '/overrideOrderEligibility'
export const  GET_API_TOKEN = DOMAIN+'/rest/api_key'

// Action Reducer 
export const  GET_STORE_DESIGN = 'GET_STORE_DESIGN'
export const  GET_ORDER_DATA   = 'GET_ORDER_DATA'
export const  CHECK_STORE_CLERK   = 'CHECK_STORE_CLERK'  
export const  GET_RMA_DETAILS =  'GET_RMA_DETAILS' 
export const  GET_ORDER_LISTING = 'GET_ORDER_LISTING'


// Pagination 
export const ROWS_PER_PAGE = 5
export const PAGE_RANGE_DISPLAYED = 10

// Returns Portal Customer Login Details
export const USER_NAME = 'customer.returns'
export const PASSWORD = '!Petsqewpet1*'



// WEBPACK FOOTER //
// ./src/AppConfig.js